import React from 'react';
import { Breadcrumb } from 'antd';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import Footer from '../../components/Footer';
import styles from './index.module.less';
import Card, { CardProps } from '../../components/Card';
import Header from '../../components/Header';
import classNames from 'classnames';

const CardLayout: React.FC<CardProps & { centered?: boolean }> = ({ centered, title, ...rest }) => {
  React.useEffect(
    () => {
      if (!document.scrollingElement) return;
      const { hash } = window.location;
      if (!hash) {
        window.scrollTo(0, 0);
        return;
      }
      const target = document.getElementById(hash.substr(1));
      if (!target) {
        window.scrollTo(0, 0);
        return;
      }
      document.scrollingElement.scrollTop += target.getBoundingClientRect().top;
    },
    [],
  );

  return (
    <div className={classNames(styles.content, centered && styles.centered)}>
      <Header placeholder />
      <div className={styles.container}>
        {
          title && (
            <Breadcrumb className={styles.breadcrumb} separator=">">
              <Breadcrumb.Item>
                <Link to="/">
                  <FormattedMessage id="Home" />
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{title}</Breadcrumb.Item>
            </Breadcrumb>
          )
        }
        <Card className={styles.card} bodyClassName={styles.body} title={title} {...rest} />
      </div>
      <Footer />
    </div>
  );
};

export default CardLayout;
